import Vue from 'vue'
import { ImagePreview } from 'vant'

Vue.prototype.$previewImage = ImagePreview